import { render } from "./ParameterContent.vue?vue&type=template&id=db8dcfdc&ts=true"
import script from "./ParameterContent.vue?vue&type=script&lang=ts"
export * from "./ParameterContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__